import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import * as reducers from './reducers';

const thresholdSimulatorSlice = createSlice({
  initialState,
  reducers,
  name: 'thresholdSimulator',
});

export const {
  setThresholdSimParamsByPublicId,
} = thresholdSimulatorSlice.actions;

export default thresholdSimulatorSlice.reducer;
